// Honorary Consuls and consular offices located in Phuket
// This is the key differentiator vs Bangkok (which has actual embassies)

export const PHUKET_HONORARY_CONSULS = {
  "ยุโรป (Europe)": [
    "🇷🇺 รัสเซีย (Russia)", "🇩🇪 เยอรมนี (Germany)", "🇫🇷 ฝรั่งเศส (France)",
    "🇮🇹 อิตาลี (Italy)", "🇪🇸 สเปน (Spain)", "🇸🇪 สวีเดน (Sweden)",
    "🇳🇴 นอร์เวย์ (Norway)", "🇫🇮 ฟินแลนด์ (Finland)", "🇨🇿 เช็กเกีย (Czechia)",
    "🇨🇭 สวิตเซอร์แลนด์ (Switzerland)", "🇳🇱 เนเธอร์แลนด์ (Netherlands)",
    "🇦🇹 ออสเตรีย (Austria)",
  ],
  "อเมริกา / โอเชียเนีย (Americas & Oceania)": [
    "🇦🇺 ออสเตรเลีย (Australia)", "🇨🇦 แคนาดา (Canada)",
    "🇺🇸 สหรัฐอเมริกา (USA — Bangkok routing)", "🇳🇿 นิวซีแลนด์ (New Zealand)",
  ],
  "เอเชีย (Asia)": [
    "🇨🇳 จีน (China)", "🇯🇵 ญี่ปุ่น (Japan)", "🇰🇷 เกาหลีใต้ (South Korea)",
    "🇮🇳 อินเดีย (India)", "🇲🇾 มาเลเซีย (Malaysia)", "🇸🇬 สิงคโปร์ (Singapore)",
  ],
  "บริการเฉพาะกิจ (Special routing via Bangkok)": [
    "🇬🇧 สหราชอาณาจักร (UK)", "🇦🇪 สหรัฐอาหรับเอมิเรตส์ (UAE)",
    "🇸🇦 ซาอุดีอาระเบีย (Saudi)", "🇮🇱 อิสราเอล (Israel)",
    "🇿🇦 แอฟริกาใต้ (South Africa)", "+ อีก 50+ ประเทศ ผ่านสถานทูตที่กรุงเทพ",
  ],
};

export const PHUKET_CONSUL_TOTAL = 22; // direct honorary consuls in Phuket province